import React, { useEffect, useRef } from "react";

const CustomCursor = () => {
    const cursor = useRef(null);
    const cursorInner = useRef(null);
    const links = useRef([]);

    useEffect(() => {
        const handleMouseMove = (e) => {
            const x = e.clientX;
            const y = e.clientY;

            if (cursor.current) {
                cursor.current.style.transform = `translate3d(calc(${x}px - 50%), calc(${y}px - 50%), 0)`;
            }
            if (cursorInner.current) {
                cursorInner.current.style.left = `${x}px`;
                cursorInner.current.style.top = `${y}px`;
            }
        };

        const handleMouseDown = () => {
            if (cursor.current) cursor.current.classList.add("click");
            if (cursorInner.current) cursorInner.current.classList.add("custom-cursor-innerhover");
        };

        const handleMouseUp = () => {
            if (cursor.current) cursor.current.classList.remove("click");
            if (cursorInner.current) cursorInner.current.classList.remove("custom-cursor-innerhover");
        };

        const handleMouseOverLink = () => {
            if (cursor.current) cursor.current.classList.add("custom-cursor-hover");
        };

        const handleMouseLeaveLink = () => {
            if (cursor.current) cursor.current.classList.remove("custom-cursor-hover");
        };

        // Attach event listeners
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("mouseup", handleMouseUp);

        // Attach event listeners to all links
        links.current.forEach((link) => {
            if (link) {
                link.addEventListener("mouseover", handleMouseOverLink);
                link.addEventListener("mouseleave", handleMouseLeaveLink);
            }
        });

        // Cleanup event listeners safely
        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("mouseup", handleMouseUp);

            links.current.forEach((link) => {
                if (link) {
                    link.removeEventListener("mouseover", handleMouseOverLink);
                    link.removeEventListener("mouseleave", handleMouseLeaveLink);
                }
            });
        };
    }, []);

    return (
        <>
            {/* Custom Cursor */}
            <div className="custom-cursor">
                <div className="custom-cursor-one" ref={cursor}></div>
                <div className="custom-cursor-two" ref={cursorInner}></div>
            </div>
        </>
    );
};

export default CustomCursor;
